/* eslint-disable */
import React from 'react';

import './style.css';
import CustomCheckboxDiv from './CustomCheckboxDiv';

const QuestionComponent = ({ question, answers, handleAnswerChange }) => {
  const { id, questionType, questionText, options } = question;

  if (questionType === 'radio') {
    return (
        <div className="question-container" key={id}>
          <p className="question-text">{questionText}</p>
          {options.map(option => (
              <div className="radio-option" key={option}>
                <input
                    id={`${id}-${option}`}
                    type="radio"
                    name={`question-${id}`}
                    value={option}
                    checked={answers[id] === option}
                    onChange={() => handleAnswerChange(id, questionType, option)}
                />
                <label htmlFor={`${id}-${option}`}>{option}</label>
              </div>
          ))}
        </div>
    );
  }

  if (questionType === 'check') {
    return (
        <div className="question-container" key={id}>
          <p className="question-text">{questionText}</p>
          {options.map(option => (
              <div className="checkbox-option" key={option}>
                <CustomCheckboxDiv
                    checked={answers[id]?.includes(option) || false}
                    onChange={() => handleAnswerChange(id, questionType, option)}
                    label={option}
                    id={`${id}-${option}`}
                />
              </div>
          ))}
        </div>
    );
  }

  return null;
};

export default QuestionComponent;
